import type { Modules } from '@kaetram/common/network';

export default class Ability {
    public active = false;
    public cooldownEnd = 0;

    public constructor(
        public type: Modules.AbilityType,
        public key: string,
        public level: number,
        public quickSlot = -1
    ) {}

    public update(level: number, quickSlot = this.quickSlot): void {
        this.level = level;
        this.quickSlot = quickSlot;
    }

    public toggle(cooldown?: number): void {
        this.active = !this.active;

        if (cooldown && cooldown > 0) this.cooldownEnd = Date.now() + cooldown;
    }

    public isOnCooldown(): boolean {
        return Date.now() < this.cooldownEnd;
    }

    public getCooldownRemaining(): number {
        return Math.max(0, this.cooldownEnd - Date.now());
    }
}
